import type ts from 'typescript';

import type { Evaluator } from '../types';

const evaluateStringLiteral: Evaluator<ts.StringLiteral> = ({ node }): string => node.text;

export default evaluateStringLiteral;
